import { createSelector } from '@ngrx/store';
import { AppState } from '../../../../store/state/app.state';
import { LoadingState } from '../state/loading.state';

export const selectLoadingState = (state: AppState) => state.loading;

export const selectShowLoadingIndicator = createSelector(selectLoadingState, (state: LoadingState) => state.showLoadingIndicator);

export const selectLoadingMessage = createSelector(selectLoadingState, (state: LoadingState) => state.loadingMessage);
